import { render, staticRenderFns } from "./formDesign.vue?vue&type=template&id=9126615c&"
import script from "./formDesign.vue?vue&type=script&lang=js&"
export * from "./formDesign.vue?vue&type=script&lang=js&"
import style0 from "./formDesign.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports